import { DEFAULT_APPEARANCE, normalizeAppearancePreferences } from "../theme/appearanceTokens";

const STORAGE_PREFIX = "admin-center.appearance.v1";
const storageKey = (userKey) => `${STORAGE_PREFIX}:${encodeURIComponent(userKey || "guest")}`;

export function loadAppearancePreferences(userKey) {
  try {
    const stored = localStorage.getItem(storageKey(userKey));
    if (stored) return normalizeAppearancePreferences(JSON.parse(stored));
    return normalizeAppearancePreferences({}, localStorage.getItem("theme"));
  } catch {
    return { ...DEFAULT_APPEARANCE };
  }
}

export function saveAppearancePreferences(userKey, preferences, resolvedMode) {
  try {
    localStorage.setItem(storageKey(userKey), JSON.stringify({ ...preferences, version: 3 }));
    localStorage.setItem("theme", resolvedMode);
  } catch {
    // Keep the selected appearance in memory when browser storage is unavailable.
  }
}

export function resetAppearancePreferences(userKey) {
  try {
    localStorage.removeItem(storageKey(userKey));
    localStorage.setItem("theme", DEFAULT_APPEARANCE.mode);
  } catch {
    // The provider still resets its in-memory state.
  }
  return { ...DEFAULT_APPEARANCE };
}
